// Tenant-course tags. The generator emits these endpoints into the cycles slice, but the policy
// is kept here so a file named for cycles does not own course invalidation. Import-free.
export const courseCacheTags = {
  listTenantCourses: {
    providesTags: [{ type: 'TenantCourses' as const, id: 'LIST' }]
  },
  getTenantCourse: {
    providesTags: (_result: unknown, _error: unknown, arg: { courseCode: string }) => [
      { type: 'TenantCourses' as const, id: arg.courseCode }
    ]
  },
  // Joins the shared list: only a catalogue variant edit moves these, and that already
  // invalidates it.
  listTenantCourseVariants: {
    providesTags: [{ type: 'CourseVariants' as const, id: 'LIST' }]
  }
  // getTenantCourseLanguages takes no tags on purpose: availability moves with ContentHub
  // publishing, never with a mutation in this app, and the read is slow.
} as const
